import combineReducers from './combineReducers';

export {
    combineReducers
};
